import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'cp-vehicles-stock-maintenance',
  templateUrl: './vehicles-stock-maintenance.component.html',
  styleUrls: ['./vehicles-stock-maintenance.component.scss']
})
export class VehiclesStockMaintenanceComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
